<div
  class="container flex w-full flex-col items-center"
  *ngIf="!(loading$ | async)">
  <rd-shared-breadcrumb
    class="ml-4 self-start lg:ml-0"
    [breadcrumbText]="
      'auto_redemption.transfer_v2.back_to_selection.title' | translate
    "
    [redirectURL]="backToDetailsPage"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'">
  </rd-shared-breadcrumb>

  <div class="desktop-container">
    <rd-shared-alert
      alertTheme="error"
      icon="error"
      class="mb-6 w-full px-4 lg:px-0"
      *ngIf="error$ | async">
      <div class="w-full">
        <p class="m-0 typo-text-mobile lg:typo-text-desktop" aria-live="polite">
          {{ 'membership.error.validation_error' | translate }}
        </p>
      </div>
    </rd-shared-alert>
    <div
      class="max-width info rounded-md mx-4 flex justify-between p-4 lg:mx-0">
      <div class="selected typo-text-mobile lg:typo-text-desktop">
        {{ 'membership.selected_redemption' | translate }}
      </div>
      <p
        class="title self-end typo-text-emphasis-1-mobile lg:self-center lg:typo-text-emphasis-1-desktop">
        {{ (checkoutForm$ | async)?.targetAmount | localizePointsNumber }}
        {{ (loyaltyProgram$ | async)?.loyaltyCurrency.name }}
      </p>
      <img
        class="image object-contain"
        alt=""
        *ngIf="loyaltyProgram$ | async as loyaltyProgram"
        [src]="loyaltyProgram.pointsTransferCapability.logoUrl" />
    </div>
    <form
      class="desktop-container flex w-full flex-col items-center px-4 lg:px-0"
      [formGroup]="form"
      (ngSubmit)="submit()"
      *ngIf="loyaltyProgram$ | async as loyaltyProgram">
      <h1 class="title self-start typo-heading-3-desktop">
        {{
          'membership.form.title'
            | translate: { loyaltyProgramName: loyaltyProgram.shortName }
        }}
      </h1>

      <p
        class="enrollment-text typo-text-desktop-4 self-start"
        *ngIf="loyaltyProgram$ | async as loyaltyProgram">
        <span class="enrollment-question">{{
          'transfer_v2.checkout.not_a_member' | translate
        }}</span>
        <rd-shared-link
          class="enrollment-url"
          [text]="'transfer_v2.checkout.join_now' | translate"
          [path]="
            loyaltyProgram.pointsTransferCapability.enrollmentUrl.toString()
          "
          [isTargetBlank]="true">
        </rd-shared-link>
      </p>
      <rd-membership-detail-form
        formGroupName="membershipForm"
        [loyaltyProgram]="loyaltyProgram"></rd-membership-detail-form>
      <p class="note self-start typo-small-text-desktop">
        <span
          class="note"
          [innerHTML]="
            'transfer_v2.link_account_dialog.disclaimer' | translate
          "></span>
      </p>
      <rd-shared-button
        class="submit-button my-6"
        [isDisabled]="
          (createOrUpdateMembershipLoading$ | async) || form.pending
        "
        buttonText="Review"
        buttonTheme="primary"
        buttonType="submit"></rd-shared-button>
    </form>
  </div>
</div>
